export async function copyToClipboard(textToCopy: string) {
  await navigator.clipboard.writeText(textToCopy);
}
